module.exports = __webpack_public_path__ + "assets/img/assist.webp?a7ca8f966d7a124ee7ec356131945e06";